<ng-container *ngIf="!showIndicators">
  <div class="d-flex flex-row justify-content-between align-items-center mt-3">
    <div class="form-inline">
      <span class="badge badge-warning">
        <span class="material-icons">smart_display</span>
      </span>
      <h4 class="mt-2">Presentaciones</h4>
    </div>
    <div class="btn-group" role="group">
      <button type="button" class="btn btn-info d-flex align-items-center" (click)="addDisplay()">
        <span class="material-icons">smart_display</span>
        <span>Agregar presentación</span>
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-6 col-md-6 col-sm-12" *ngFor="let display of displays">
      <div class="card">
        <div class="card-header text-center card-header-plus" style="text-transform: uppercase;">
          <a class="btn btn-floating halfway-fab bg-warning" ngbTooltip="Agregar indicadores a la presentación" (click)="addIndicators(display)" style="background-color: #D46010 !important;">
            <i class="ft-plus"></i>
          </a>
        </div>
        <div class="card-body">
          <table class="table table-bordered">
            <thead>
            <tr style="background-color: #5D6B99 !important;">
              <th colspan="2" class="text-center" style="font-weight: bold; color: #FFFFFF; text-transform: uppercase;">{{display.name}}</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td class="text-center" style="border: none;">
                <div style="display: flex; align-items: center; justify-content: start;">
                  <img src="{{display.picture}}" alt="Responsable" style="width: 100px; height: 100px; object-fit: cover; border-radius: 50%; margin-right: 10px;">
                  <span style="margin-left: 20px; text-transform: uppercase !important;">{{display.responsable}}</span>
                </div>
              </td>
              <td class="text-center" style="border: none;">
                <!-- Se ajusta el div para que tenga el mismo ancho que la celda del hombre -->
                <div style="display: flex; align-items: center; justify-content: center; width: 200px; margin: auto">
                  <!-- La imagen se ajustará al ancho del div -->
                  <img src="../../../assets/img/dtroy/cardDtroy.jpg" alt="Responsable" style="width: 100%; height: auto; object-fit: cover; border-radius: 0;">
                </div>
              </td>
            </tr>
            </tbody>

          </table>
          <app-indicator-mod [indicatorsIds]="display.indicators"></app-indicator-mod>
          <button type="button" class="btn btn-warning mt-6" (click)="viewIndicators(display)" style="background-color: #97B0DD !important;color: #1A051D !important;">
            <span style="font-weight: bold">Ver presentación</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-container>


<ng-container *ngIf="showIndicators">
  <div class="body-indicators">
    <div class="display-header">
      <div class="d-flex flex-row justify-content-start align-items-center mt-3 mb-3">
        <button type="button" class="btn btn-secondary d-flex align-items-center" (click)="goBack()">
                    <span class="material-icons">
                        arrow_back
                    </span>
          <span>Todas las presentaciones</span>
        </button>
        <div class="d-inline-flex">
                    <span class="badge badge-warning">
                        <span class="material-icons">
                            trending_up
                        </span>
                    </span>
          <h4 class="title-page">
                        <span>
                            Indicadores de:
                        </span>
            <span>
                            {{selectedDisplay.name}}
                        </span>
          </h4>
        </div>
      </div>
    </div>
    <div class="display-table">
      <ng-container *ngIf="selectedDisplay.indicators">
        <app-indicator-table-show [indicatorsIds]="selectedDisplay.indicators"></app-indicator-table-show>
      </ng-container>
    </div>
  </div>
</ng-container>
<style>
  .card {
    min-height: 700px; /* Ajusta esta altura para que se acomode a la altura de 5 filas */
    display: flex;
    flex-direction: column;
    justify-content: space-between; /* Esto asegurará que el botón 'Ver presentación' se mantenga al fondo */
  }
  .card-header-plus {
    position: relative;
  }

  .btn-floating {
    position: absolute;
    top: 10px; /* Ajusta según sea necesario */
    right: 10px; /* Ajusta según sea necesario */
  }

  .card-body {
    flex: 1; /* Esto permite que el cuerpo de la tarjeta se expanda para ocupar cualquier espacio disponible */
    display: flex;
    flex-direction: column;
  }


  /* Asegúrate de que todas las columnas de la fila tengan la misma altura */
  .row {
    display: flex;
  }
  .card-header-plus {
    position: relative;
  }
  .card-header-plus .btn-floating {
    position: absolute;
    top: 10px; /* Ajusta según sea necesario */
    right: 10px; /* Ajusta según sea necesario */
  }



  .card-header{
    background-color: #5D6B99 !important;
    color: white !important;
    font-weight: bold;
  }





</style>
